export const stringToNumber = (v: string) => {
	const originalValue = v.includes(',') ?  v.replace(',', '.') : v;
	const newValue = parseFloat(originalValue);
	if (isNaN(newValue)) return 0;
	return newValue;
};
